import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../const";
// @ts-ignore
import {SystemLogType} from "../../../../core/gd/const/system-log";

export default class SettingsReplyTaskByEmailLogs extends SettingsModule {

    constructor() {
        super({
            name                     : "Reply Task by Email",
            description              : "",
            svgIcon                  : "isvg-logs",
            typeLabel                : "Organization account",
            settingsUrl              : `settings/logs-email-task-reply/${SystemLogType.EMAIL_REPLY}`,
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION
        });

        this.parentSection          = SettingsParentSection.SYSTEM

        this.canDisable             = false
        this.hasStatus              = false
    }

}
